import { Component, inject, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { fromToolbar, ToolbarActions } from 'shared/classroom/toolbar/data-access';
import { map } from "rxjs/operators";
import { ToolbarButtonComponent } from '../toolbar-button.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'pcp-slide-sync-toolbar-button-pencil',
    templateUrl: './toolbar-button-pencil.component.html',
    styleUrls: ['./toolbar-button-pencil.component.scss'],
    imports: [ToolbarButtonComponent, AsyncPipe]
})
export class ToolbarButtonPencilComponent {

    @Input() icon = 'create';
    @Input() fontSet = '';

    private readonly store: Store = inject(Store);

    readonly isDisabled$ = this.store.select(
        fromToolbar.isDrawingEnabled
    ).pipe(
        map(isDrawingEnabled => !isDrawingEnabled),
    );

    readonly isActivated$ = this.store.select(
        fromToolbar.selectActivatedDrawingTool
    ).pipe(
        map(activatedTool => activatedTool === 'pencil')
    );

    public toggle() {
        this.store.dispatch(
            ToolbarActions.toggleDrawingTool({ toolName: 'pencil' })
        );
    }
}

